import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

/**
 * Type guard to check if a field is a BooleanField.
 *
 * @param field - The field to check.
 * @returns True if the field is a BooleanField, otherwise false.
 */
export const isBooleanField = (field: unknown): field is Field<'False' | 'True'> => {
  return (
    typeof field === 'object' &&
    field !== null &&
    'value' in field &&
    typeof (field as Field).value === 'string' &&
    ['False', 'True'].includes((field as Field<string>).value)
  );
};
